import { EncryptStorage } from 'encrypt-storage';

// export const encryptStorage = EncryptStorage(process.env.REACT_APP_STORAGE_KEY, { storageType: "sessionStorage" })
export const encryptStorage = EncryptStorage(process.env.REACT_APP_STORAGE_KEY, { storageType: "localStorage" })